import axios from "axios";
import { apiUrl } from "../constant";

const API_BASE = `${apiUrl}/api`;

// Get package assignment list with filters and pagination
export const getPackageAssignmentListService = (data) => {
    return axios.post(`${API_BASE}/IncomingPackage/GetPackagesForApproval`, data, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// Approve a single package assignment
export const approvePackageAssignmentService = (packageId, comments = '') => {
    return axios.post(`${API_BASE}/ApproveAssignment`, {
        packageId,
        comments,
        approvedBy: null // Will be set on backend based on auth token
    }, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// Reject a single package assignment
export const rejectPackageAssignmentService = (packageId, comments) => {
    return axios.post(`${API_BASE}/RejectAssignment`, {
        packageId,
        comments,
        rejectedBy: null // Will be set on backend based on auth token
    }, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// Bulk approve package assignments
export const bulkApproveAssignmentsService = (packageIds, comments = '') => {
    return axios.post(`${API_BASE}/BulkApproveAssignments`, {
        packageIds,
        comments,
        approvedBy: null // Will be set on backend based on auth token
    }, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// Bulk reject package assignments
export const bulkRejectAssignmentsService = (packageIds, comments) => {
    return axios.post(`${API_BASE}/BulkRejectAssignments`, {
        packageIds,
        comments,
        rejectedBy: null // Will be set on backend based on auth token
    }, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// Get package assignment details by ID
export const getPackageAssignmentByIdService = (id) => {
    return axios.get(`${API_BASE}/GetAssignmentById/${id}`, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// Export package assignment data
export const exportPackageAssignmentService = (data) => {
    return axios.post(`${API_BASE}/ExportAssignments`, data, {
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// Get assignment history for a package
export const getPackageAssignmentHistoryService = (packageId) => {
    return axios.get(`${API_BASE}/GetAssignmentHistory/${packageId}`, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// Get assignment statistics for dashboard
export const getPackageAssignmentStatsService = () => {
    return axios.get(`${API_BASE}/GetAssignmentStats`, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
};